import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-file-system",
  "use": "app-icon-file-system-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"app-icon-file-system\"><g fill=\"#FFF\" fill-rule=\"nonzero\"><path d=\"M4 7v34a1 1 0 001 1h39a1 1 0 001-1V11.38a1 1 0 00-1-1H26.453a1 1 0 01-.548-.163l-6.186-4.053A1 1 0 0019.171 6H5a1 1 0 00-1 1zm2 1h12.873l5.935 3.89a3 3 0 001.645.49H43V40H6V8z\" /><path d=\"M5 19.5h39v-1H5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol